import React, {useEffect, useState} from "react";
import styled from "styled-components";

export const Button = ({...props}) => {
	const getClassName = () => {
		const nameList = (props.className || "").split(" ");
		if(props.icon) nameList.push("icon");
		if(props.size) nameList.push("size");
		if(props.round) nameList.push("round");
		if(props.outline) nameList.push("outline");
		if(props.color) nameList.push(props.color);
		return nameList.join(" ");
	};

	return (
		<StyledButton className={getClassName()} type={props.type || "button"} {...props}>
			{props.children}
		</StyledButton>
	);
};

const StyledButton = styled.button`
	display: block;
	padding: 0 10px;
	width: 100%;
	background-color: var(--darkBlue);
	border-radius: 8px;
	border: 1px solid var(--darkBlue);
	line-height: var(--lineHeight);
	color: var(--white);
	text-align: center;
	
	&.icon					{background:url(${(props) => props.icon}) no-repeat center center / 24px}
	&.red					{background-color:var(--red); border-color:var(--red)}
	&.green					{background-color:var(--green); border-color:var(--green)}
	&.blue					{background-color:var(--blue); border-color:var(--blue)}
	&.purple				{background-color:var(--purple); border-color:var(--purple)}
	&.black					{background-color:var(--black); border-color:var(--black)}
	&.white					{background-color:var(--white); border-color:var(--gray); color:var(--black)}
	&.gray					{background-color:var(--gray); border-color:var(--gray)}
	&:disabled				{background-color:var(--disabled) !important; border-color:var(--disabled) !important; color:var(--disabled) !important}

	&.round					{border-radius:100px}

	&.outline				{background-color:white; color:var(--darkBlue)}
	&.outline.red			{border-color:var(--red); color:var(--red)}
	&.outline.green			{border-color:var(--green); color:var(--green)}
	&.outline.blue			{border-color:var(--blue); color:var(--blue)}
	&.outline.purple		{border-color:var(--purple); color:var(--purple)}
	&.outline.black			{border-color:var(--black); color:var(--black)}
	&.outline.gray			{border-color:var(--gray); color:var(--gray)}
	&.outline.lightGray		{border-color:var(--border); color:#515458}

	&:focus					{box-shadow:0 0 0 3px rgba(66,72,90,0.3)}
	&.red:focus				{box-shadow:0 0 0 3px rgba(255,87,34,0.3)}
	&.green:focus			{box-shadow:0 0 0 3px rgba(55,183,114,0.3)}
	&.blue:focus			{box-shadow:0 0 0 3px rgba(33,150,243,0.3)}
	&.purple:focus			{box-shadow:0 0 0 3px rgba(122,82,204,0.3)}
	&.black:focus			{box-shadow:0 0 0 3px rgba(0,0,0,0.2)}
	&.gray:focus,
	&.lightGray:focus		{box-shadow:0 0 0 3px rgba(0,0,0,0.1)}
	&.white:focus			{box-shadow:0 0 0 3px rgba(0,0,0,0.1)}
	
	& + &					{margin-top:10px}
`;

export default Button;